<template>
  <div class="wrap">
    <img class="shareimg" src="../../assets/img/shareimg.png" alt="" />
    <div class="shareFixed">
      <van-button style=" font-size: 20px;" @click="back" block>点击了解 立享8折优惠</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      btnName: '点击了解详情',
      sale: null,
    };
  },
  created() {},
  methods: {
    back() {
      this.$router.push({
        path: '/vip',
        query: { icoi: this.$route.query.icoi || null },
      });
    },
  },
};
</script>
<style scoped>
.wrap {
  position: relative;
  background: #b60309;
  height: 100vh;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.shareimg {
  width: 100%;
  display: block;
}
.shareFixed {
  background: linear-gradient(to right, #ff6034, #ee0a24);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  font-size: 20px;
}
</style>
